import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — an open laptop authored at floor level (the builder sets
// it on a desk): a base slab with a keyboard-tone inset and a screen panel
// tilted back, hinged at the rear edge. Matte black with a dark-glass screen.
const MATTE_BLACK = "#2e2e30";
const KEYS = "#4a4e52";
const DARK_GLASS = "#3a3f44";

// The lid is hinged at the back edge of the base (z = -0.11, y = 0.02) and
// tilts back by 0.35 rad; part centres below are computed from that hinge.
export const laptop = defineModel({
  id: "laptop",
  batchId: "modern",
  name: "Laptop",
  tags: ["modern", "interior", "appliance", "electronics", "office", "computer", "portable"],
  summary: "An open matte-black laptop with a dark-glass screen tilted back.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // base slab
      { geometry: new THREE.BoxGeometry(0.34, 0.02, 0.24), color: MATTE_BLACK, position: [0, 0.01, 0.01] },
      // keyboard-tone inset on top of the base
      { geometry: new THREE.BoxGeometry(0.3, 0.006, 0.13), color: KEYS, position: [0, 0.023, -0.02] },
      // touchpad
      { geometry: new THREE.BoxGeometry(0.1, 0.006, 0.06), color: KEYS, position: [0, 0.023, 0.08] },
      // screen lid, hinged at the back edge and tilted back
      {
        geometry: new THREE.BoxGeometry(0.34, 0.23, 0.014),
        color: MATTE_BLACK,
        position: [0, 0.128, -0.149],
        rotation: [-0.35, 0, 0],
      },
      // dark-glass screen face on the lid's front (+Z) side
      {
        geometry: new THREE.BoxGeometry(0.31, 0.2, 0.006),
        color: DARK_GLASS,
        position: [0, 0.131, -0.139],
        rotation: [-0.35, 0, 0],
      },
    ];
  },
  animations: [],
});
